import React from 'react';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';

function VideoSlider({ videos }) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>
        {videos?.length &&
          videos?.map((url, index) => {
            return (
              <div className="px-2  h-52" key={index}>
                <ReactPlayer
                  className="react-player"
                  controls
                  url={url}
                  width="100%"
                  height="100%"
                />
              </div>
            );
          })}
      </Slider>
    </div>
  );
}

export default VideoSlider;
